import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import CategoryGrid from './components/CategoryGrid';
import HotArticles from './components/HotArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <StatsSection />
        <CategoryGrid />
        <HotArticles />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}